import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AppRedirectService } from 'src/app/services/app-redirect.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-race-share-success-handling',
  templateUrl: './race-share-success-handling.component.html',
  styleUrls: ['./race-share-success-handling.component.scss']
})
export class RaceShareSuccessHandlingComponent {

  translationData: any[] = [];
  @Input() error_header: any;
  @Input() error_sub_heading_1: any;
  error_sub_heading_2: any;
  showSpinner$!: Observable<boolean>;
  hasBanner: boolean = false;

  constructor(private readonly translationService: TranslationService, 
    private readonly appRedirectService: AppRedirectService) { }

  ngOnInit() {

   
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.hasBanner = this.appRedirectService.checkBannerPresence();
    });
  }

  triggerGoToMyStories() {
    this.showSpinner$ = this.appRedirectService.showSpinner$;
    setTimeout(() => {
      this.appRedirectService.closeSpinner();
    }, 3000);
    this.appRedirectService.triggerGoToApp();
  }


}
